export const BATHROOM_COLLECTIONS_PATH = '/promo/nabory-mebeli-dlya-vannoy/';

export const BATHROOM_COLLECTIONS_ELEMENT_BLOCK = 'naboryVann / catalogue';

export const BATHROOM_COLLECTIONS_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/bathroom-collections';

export const BATHROOM_COLLECTIONS_LANDING_NAME = 'bathroom-collections';

export const BATHROOM_COLLECTIONS_CATEGORY_ID = '325';

export const BATHROOM_COLLECTIONS_DESIGN_BANNER_STRUCTURE = {
  bgColor: '#438286',
  elementBlock: BATHROOM_COLLECTIONS_ELEMENT_BLOCK,
  content: {
    media: {
      alt: 'Ванная комната',
      srcD: `${BATHROOM_COLLECTIONS_CDN_PATH}/banner/bathroom-d.jpg/bathroom-d.jpg`,
      srcT: `${BATHROOM_COLLECTIONS_CDN_PATH}/banner/bathroom-t.jpg/bathroom-t.jpg`,
      src: `${BATHROOM_COLLECTIONS_CDN_PATH}/banner/bathroom-m.jpg/bathroom-m.jpg`,
    },
    title: 'Не\u00A0нашли подходящий дизайн?',
    text: 'Спроектируйте свою идеальную ванную комнату',
  },
  link: {
    href: '/uslugi/proektirovanie-i-dizayn/sozdayte-vannuyu-komnatu-svoey-mechty/',
    title: 'Бесплатный проект ванной комнаты',
  },
  promotion: {
    name: `${BATHROOM_COLLECTIONS_ELEMENT_BLOCK}_middle`,
    creative: 'Не нашли подходящий дизайн',
    position: '1',
  },
};
